import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { LoadingStore } from '../app/data/loading/loading.store';

export function loadingInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const loadingStore = inject(LoadingStore);
  loadingStore.requestStarted();

  return next(req).pipe(finalize(() => loadingStore.requestEnded()));
}
